import { render, staticRenderFns } from "./followup.vue?vue&type=template&id=20ec626c&scoped=true"
import script from "./followup.vue?vue&type=script&lang=js"
export * from "./followup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec626c",
  null
  
)

export default component.exports